import { Button, Col, COLORS, Row, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';
import React from 'react';
import { useParams } from 'react-router-dom';

const Container = styled.div`
  max-width: 900px;
  padding: 2rem;
  background: ${COLORS.WHITE};
  line-height: 1.6;
`;

const List = styled.ul`
  margin-left: 1.5rem;
  padding-left: 0;
`;

const ListItem = styled.li`
  margin: 0.4rem 0;
`;

const Highlight = styled.span`
  font-weight: 600;
  color: ${COLORS.BLACK};
`;

const PausePolicy = () => {
  const { id: studentId } = useParams();
  const handlePress = url => {
    return window.open(url, '_blank');
  };

  return (
    <Container>
      <Row>
        <Text variant="h4" color={COLORS.BLACK}>
          New Student Pause Policy <br />
          (Started from 10 September 2025)
        </Text>
        <Col autoRight>
          <Button
            size="small"
            label="Student leave usage"
            onClick={() =>
              handlePress(
                `https://admin.cuemath.com/classroom/admin/studentleaveusage/?search=${studentId}`,
              )
            }
          />
        </Col>
        <Col>
          <Button
            size="small"
            label="Student leave grant"
            onClick={() =>
              handlePress(
                `https://admin.cuemath.com/classroom/admin/studentleavegrant/?search=${studentId}`,
              )
            }
          />
        </Col>
      </Row>
      <Separator transparent height="16" />
      <Text variant="body1" color={COLORS.BLACK}>
        This document outlines our revised Pause Policy for Cuemath students. The new
        policy addresses several challenges in the current system by introducing a
        simplified, user-friendly approach based on better pause application logic.
      </Text>
      <List>
        <ListItem>
          <Text variant="body1" color={COLORS.BLACK}>
            1. Pausing of Classes
          </Text>
        </ListItem>
        <ListItem>
          <Text variant="body1" color={COLORS.BLACK}>
            2. Pause Cancellation and Class Restoration
          </Text>
        </ListItem>
      </List>
      <Text variant="body1" color={COLORS.BLACK}>
        Let’s go through them one by one.
      </Text>
      <Separator transparent height="16" />
      <Text variant="h6" color={COLORS.BLACK}>
        1. Pausing of Classes
      </Text>
      <List>
        <ListItem>
          - A Parent may utilize a Pause Unit to a Scheduled Class exclusively through the
          Cuemath Application. A request to Pause a Schedule Class can be initiated using
          the Cuemath Application on behalf of the Student, up to 05 (five) minutes before
          the Scheduled Class start time. No other means of request will be considered
          valid.
        </ListItem>
        <ListItem>
          - Parents shall be solely responsible for ensuring that pause requests are
          submitted in a timely manner through the Cuemath Application and in accordance
          with the process set forth herein. If a Parent fails to submit a Pause request
          within the stipulated timeframe/ and the Student fails to attend the Scheduled
          Class without applying for the necessary Pause, the status of a Scheduled Class
          shall remain unchanged and the Company shall bear no liability for the same, and
          such Lapsed Class will not be eligible for rescheduling, refund, or
          compensation, monetary or otherwise.
        </ListItem>
        <ListItem>
          - Each pause shall result in the deduction of one (1) Pause Unit, and the
          balance of available Pause Units shall be reflected in the Cuemath Application.
          In the event of a valid Pause Cancellation in accordance with this Policy, the
          Company may restore the corresponding Pause Unit to the Student’s account.
        </ListItem>
        <ListItem>
          - Each pause request shall result in the utilization of one (one) Pause Unit,
          and the available Pause Units shall be reflected in the Cuemath Application.
        </ListItem>
        <ListItem>
          - The Company shall not accept or process any Pause requests raised outside the
          Cuemath Application (including by phone, email, or Tutor communication).
        </ListItem>
      </List>
      <Text variant="h6" color={COLORS.BLACK}>
        2. Pause Cancellation and Class Restoration
      </Text>
      <List>
        <ListItem>
          - Parents may request cancellation of active pause through the Cuemath
          application. Paused classes shall be restored to the student's schedule subject
          to Tutor availability.
        </ListItem>
        <ListItem>
          - Pause cancellation requests shall be processed based on the following
          timeframes:
        </ListItem>
        <List>
          <ListItem>
            1. <Highlight>More than 24 hours before a paused range : </Highlight>
            Cancellation of previously applied pause and immediate restoration of the
            classes to the original schedule without requiring an approval from the Tutor.
          </ListItem>
          <ListItem>
            2. <Highlight>Within 24 hours to 15 minutes before a paused range:</Highlight>{' '}
            Request sent to Tutor for approval based on availability.
          </ListItem>
          <ListItem>
            3. <Highlight>Within 15 minutes before paused range:</Highlight> Pause
            Cancellation not permitted.
          </ListItem>
        </List>
        <ListItem>
          - Allocated on the 1st of every month, with{' '}
          <Highlight>no carry forward</Highlight>.
        </ListItem>
        <ListItem>
          <Highlight>Within 24 hours to 15 minutes before a paused range:</Highlight>{' '}
          Request sent to Tutor for approval based on availability.
        </ListItem>
      </List>
    </Container>
  );
};

export default PausePolicy;
